import { Injectable } from '@angular/core';
import { environment } from '../../environments';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { observable, Observable, of, throwError as _throw } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { SYSTEMNOTIFICATIONMOCKSET } from '../views/partials/layout/topbar/notification/mock/notifications.table';
import { SystemNotificationItem } from '../models/system-notification-item';
import { INotificationDto } from '../contracts/INotificationDto';
import packageInfo from '../../../package.json';
const version = packageInfo.version;

@Injectable({
  providedIn: 'root'
})
export class AppService {

  private apiEndPoint: string;

  constructor(
    private _http: HttpClient,
    private _translate: TranslateService
  ) { 
    this.apiEndPoint = environment.apiUrl;
  }

  getAppVersion(): Observable<string> {
    const params = new HttpParams();

    return of(version);  
  }

  getSystemNotification(): Observable<SystemNotificationItem[]> {
    const params = new HttpParams();
    return this._http.get<INotificationDto[]>(`${this.apiEndPoint}/Notification/GetAllByTop`, { params })
    .pipe(
      map( res => {
        return res.map(x => new SystemNotificationItem().mapFromNotificationDto(x));
      }),
      catchError(err => {
        if (err.errorcode) {
          return _throw(err.errorcode);
        }

        return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
      })
    );
  }

  notifySystemAlert(item: SystemNotificationItem): Observable<boolean> {
    return this._http.post(`${this.apiEndPoint}/Notification/ReadNotificationsById`, item.id)
    .pipe(
      map( res => {
        return true;          
      }),
      catchError(err => {
        if (err.errorcode) {
          return _throw(err.errorcode);
        }
        return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
      })
    );   
  }

}
